import FormSection from './FormSection'
import { translations } from '../../data/translations'
import './FormSection.css'

const ContentSection = ({ formData, updateFormData, language }) => {
  const t = translations[language]?.content || translations.de.content

  const handleCheckboxChange = (field, value, checked) => {
    const current = formData[field] || []
    const updated = checked
      ? [...current, value]
      : current.filter(v => v !== value)
    updateFormData(field, updated)
  }

  return (
    <FormSection title={t.title} subtitle={t.subtitle}>
      <h3 className="form-section__subtitle">{t.subtitle1}</h3>
      
      <div className="form-group">
        <label className="form-group__label">{t.seitenLabel}</label>
        <div className="checkbox-group" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', gap: '8px' }}>
          {t.seitenOptions.map((option) => (
            <label key={option.value} className="radio-group__option" style={{ padding: '8px 12px' }}>
              <input
                type="checkbox"
                name="seiten[]"
                value={option.value}
                checked={(formData.seiten || []).includes(option.value)}
                onChange={(e) => handleCheckboxChange('seiten', option.value, e.target.checked)}
              />
              <span className="radio-group__label" style={{ fontSize: '0.9rem' }}>{option.label}</span>
            </label>
          ))}
        </div>
      </div>

      <div className="form-group">
        <label htmlFor="seiten_weitere" className="form-group__label">
          {t.seiten_weitere}
        </label>
        <input
          type="text"
          id="seiten_weitere"
          name="seiten_weitere"
          className="form-group__input"
          placeholder={t.seiten_weiterePlaceholder}
          value={formData.seiten_weitere || ''}
          onChange={(e) => updateFormData('seiten_weitere', e.target.value)}
        />
      </div>

      <h3 className="form-section__subtitle">{t.subtitle2}</h3>

      <div className="form-group">
        <label className="form-group__label">
          {t.sprachenLabel} <span className="form-group__required">*</span>
        </label>
        <div className="checkbox-group">
          {t.sprachenOptions.map((option) => (
            <label key={option.value} className="radio-group__option">
              <input
                type="checkbox"
                name="sprachen[]"
                value={option.value}
                checked={(formData.sprachen || []).includes(option.value)}
                onChange={(e) => handleCheckboxChange('sprachen', option.value, e.target.checked)}
                required={!(formData.sprachen || []).length}
              />
              <span className="radio-group__label">{option.label}</span>
            </label>
          ))}
        </div>
      </div>

      {(formData.sprachen || []).includes('andere') && (
        <div className="form-group">
          <label htmlFor="lang_andere_text" className="form-group__label">
            {t.lang_andere_text}
          </label>
          <input
            type="text"
            id="lang_andere_text"
            name="lang_andere_text"
            className="form-group__input"
            placeholder={t.lang_andere_textPlaceholder}
            value={formData.lang_andere_text || ''}
            onChange={(e) => updateFormData('lang_andere_text', e.target.value)}
          />
        </div>
      )}

      <div className="form-group">
        <label htmlFor="content_bereitstellung" className="form-group__label">
          {t.content_bereitstellung}
        </label>
        <select
          id="content_bereitstellung"
          name="content_bereitstellung"
          className="form-group__input"
          value={formData.content_bereitstellung || ''}
          onChange={(e) => updateFormData('content_bereitstellung', e.target.value)}
        >
          <option value="">{t.bitteWaehlen}</option>
          {t.content_bereitstellungOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    </FormSection>
  )
}

export default ContentSection
